var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-results-grid-wrapper" }, [
    _c(
      "div",
      { staticClass: "search-results-grid container" },
      [
        _vm.currentResults.length > 0
          ? _c("div", { staticClass: "search-results-grid__total" }, [
              _c("span", [_vm._v(_vm._s(_vm.resultsText))])
            ])
          : _vm._e(),
        _c(
          "fade-transition",
          { attrs: { duration: { enter: 1000, leave: 300 }, group: "" } },
          [
            _vm.currentResults && _vm.currentResults.length < 1
              ? _c(
                  "div",
                  {
                    key: "noresults",
                    staticClass: "search-results-grid__no-results"
                  },
                  [
                    _c("h3", [
                      _vm._v(
                        "There are no " +
                          _vm._s(_vm.currentTab.slice(0, -1)) +
                          ' results for "' +
                          _vm._s(_vm.searchTerm) +
                          '"'
                      )
                    ]),
                    _vm.totalResults
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "search-results-grid__no-results-other-results"
                          },
                          [
                            _c("p", [
                              _vm._v("Other Results:"),
                              _vm.totalProducts
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.totalProducts +
                                          " " +
                                          (_vm.totalProducts > 1
                                            ? "products"
                                            : "product")
                                      ) +
                                        _vm._s(
                                          "" +
                                            (_vm.totalArticles || _vm.totalPages
                                              ? ","
                                              : "")
                                        )
                                    )
                                  ])
                                : _vm._e(),
                              _vm.totalArticles
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.totalArticles +
                                          " " +
                                          (_vm.totalArticles > 1
                                            ? "articles"
                                            : "article")
                                      ) +
                                        _vm._s("" + (_vm.totalPages ? "," : ""))
                                    )
                                  ])
                                : _vm._e(),
                              _vm.totalPages
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.totalPages +
                                          " " +
                                          (_vm.totalPages > 1
                                            ? "pages"
                                            : "page")
                                      )
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _c(
                      "v-button",
                      {
                        staticClass:
                          "search-results-grid__no-results-button button button--primary",
                        class: _vm.searchCtaSettings.cta,
                        attrs: { href: _vm.searchCtaSettings.url, tag: "a" }
                      },
                      [_vm._v(_vm._s(_vm.searchCtaSettings.text))]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm.currentTab === "products" && _vm.currentResults.length >= 1
              ? _c(
                  "div",
                  {
                    key: "products",
                    staticClass: "search-results-grid__products grid"
                  },
                  _vm._l(_vm.paginatedResults, function(product) {
                    return _c("search-results-tile", {
                      key: product.id,
                      attrs: { data: product, tileType: _vm.currentTab }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.currentTab === "articles" && _vm.currentResults.length >= 1
              ? _c(
                  "div",
                  {
                    key: "articles",
                    staticClass: "search-results-grid__articles grid"
                  },
                  _vm._l(_vm.paginatedResults, function(article) {
                    return _c("search-results-tile", {
                      key: article.url,
                      attrs: { data: article, tileType: _vm.currentTab }
                    })
                  }),
                  1
                )
              : _vm._e(),
            _vm.currentTab === "pages" && _vm.currentResults.length >= 1
              ? _c(
                  "div",
                  {
                    key: "pages",
                    staticClass: "search-results-grid__pages grid"
                  },
                  _vm._l(_vm.paginatedResults, function(page) {
                    return _c("search-results-tile", {
                      key: page.url,
                      attrs: { data: page, tileType: _vm.currentTab }
                    })
                  }),
                  1
                )
              : _vm._e()
          ]
        ),
        _c("search-results-pagination-controls", {
          attrs: {
            pages: _vm.currentTotalPages,
            "pagination-amount": _vm.paginationAmount,
            "current-page": _vm.currentPage
          },
          on: { "go-to-page": _vm.goToPage }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }